// eslint-disable-next-line import/no-namespace
import * as Octicons from '@primer/octicons-react'
import {Box, Card, Grid} from '@primer/react-brand/esm'
import {clsx} from 'clsx'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import Styles from './CardsSection.module.css'
import {SectionHeader} from '../SectionHeader/SectionHeader'

export interface CardsSectionItem {
  heading: string
  body: string
  cta: {
    label: string
    href: string
  }
  iconName: Exclude<keyof typeof Octicons, 'default'>
}

export interface CardsSectionProps {
  heading: string
  body?: string
  items: CardsSectionItem[]
  location?: string
}

export const CardsSection = ({heading, body, items, location}: CardsSectionProps) => {
  return (
    <div className={Styles['CardsSection']}>
      <SectionHeader heading={heading} body={body} />

      <Box className={Styles['CardsSection__gridFrame']}>
        <Box className={clsx(Styles['CardsSection__gridContent'], Styles['CardsSection__gridContentWide'])}>
          <Grid columnGap="none" rowGap="none" enableGutters={false}>
            {items.map((item, index) => (
              <Grid.Column
                // eslint-disable-next-line @eslint-react/no-array-index-key
                key={`card-${index}`}
                span={{xsmall: 12, large: 4}}
                className={clsx(Styles['CardsSection__gridColumn'], Styles['CardsSection__gridColumnArrowHover'])}
              >
                <Box className={Styles['CardsSection__gridItem']} padding={24}>
                  <Card
                    href={item.cta.href}
                    fullWidth
                    ctaVariant="arrow"
                    ctaText={item.cta.label}
                    {...getAnalyticsEvent({action: item.cta.label, tag: 'a', context: `card_${index + 1}`, location})}
                  >
                    <Card.Icon icon={Octicons[item.iconName]} color="green" hasBackground />
                    <Card.Heading>{item.heading}</Card.Heading>
                    <Card.Description>{item.body}</Card.Description>
                  </Card>
                </Box>
              </Grid.Column>
            ))}
          </Grid>
        </Box>
      </Box>
    </div>
  )
}
